// extracted by mini-css-extract-plugin
module.exports = {"item":"Subscription_item__ui_RW"};